import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Main } from './Main';
import "./assets/css/style.css";
import "./assets/css/bootstrap.min.css";

import { Login } from './pages/Login/Login';
import { Signup } from './pages/Signup/Signup';
import { Header } from './components/header';
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store,persistor } from './appRedux/store';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
//   <Provider store={store}>
//   <PersistGate loading={null} persistor={persistor}>
//     <Main />
//   </PersistGate>
// </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
